/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NbRoleProvider } from '@nebular/security';
import { hasAnyRole, ROLES } from './roles';

// only administrators manage payroll; everyone else (staff included) just gets My Payslips
const PAYROLL_ADMIN_ROLES = [
  ROLES.ADMIN,
];

export const IsAuthorizedForAdminManagement = (role) => {
  return hasAnyRole(role, [ROLES.ADMIN]);
}

export const IsAuthorizedForPayrollManagement = (role) => {
  return hasAnyRole(role, PAYROLL_ADMIN_ROLES);
}

@Injectable()
export class AdminGuard implements CanActivate {
  constructor(private roleProvider: NbRoleProvider, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.roleProvider.getRole()
      .pipe(map(role => IsAuthorizedForAdminManagement(role)
        ? true
        : this.router.createUrlTree(['/pages/dashboard'])));
  }
}

@Injectable()
export class PayrollAdminGuard implements CanActivate {
  constructor(private roleProvider: NbRoleProvider, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.roleProvider.getRole()
      .pipe(map(role => IsAuthorizedForPayrollManagement(role)
        ? true
        : this.router.createUrlTree(['/pages/payroll/my-payslips'])));
  }
}
